import {
  IJoinProps,
  manInfProps,
  IManList,
  manModifyProps,
  userSearchProps,
} from "interface/member";
import api from "./api";
import { page } from "interface";

const memUrl = "login/";

// 로그아웃
export const logoutApi = async () => {
  const res = await api({
    method: "get",
    url: memUrl + "logout",
  });

  return res;
};

// 회원정보 조회 비밀번호 확인
export const lgnPwdChkApi = async (params: {
  emlId: string;
  lgnPwd: string;
}) => {
  const res = await api({
    method: "post",
    url: memUrl + "lgnPwdChk",
    data: params,
  });

  return res;
};

//매니저 로그인
export const managerLoginApi = async (params: {
  emlId: string;
  lgnPwd: string;
}) => {
  const res = await api({
    method: "post",
    url: memUrl + `lgnProc`,
    data: params,
  });

  return res;
};

// 매니저 회원가입
export const joinDefaultApi = async (params: manInfProps) => {
  const res = await api({
    method: "post",
    url: "join/apply",
    data: params,
  });
  return res;
};

// 매니저 회원가입 인증메일
export const joinMailAuthApi = async (params: { certEncParam: string }) => {
  const res = await api({
    method: "get",
    url: `join/certInfo?param=${params.certEncParam}`,
    // data: params,
  });

  return res;
};

// 매니저 회원가입 비밀번호 들록
export const joinApi = async (params: IJoinProps) => {
  const res = await api({
    method: "post",
    url: "join/certJoin",
    data: params,
  });

  return res;
};

//비밀번호 설정 회원정보 확인
export const resetPwdInfCheckApi = async (params: manInfProps) => {
  const res = await api({
    method: "post",
    url: memUrl + "lgnPwdReset",
    data: params,
  });

  return res;
};

// 비밀번호 찾기 메일 인증
export const resetPwdAuthApi = async (params: {
  certEncParam: string;
  // newLgnPwd: string;
}) => {
  const res = await api({
    method: "post",
    url: memUrl + "certChk",
    data: params,
  });
  return res;
};
// export const resetPwdChkApi = async () => {};
// 비밀번호 설정
export const resetPwdApi = async (parmas: {
  certEncParam: string;
  newLgnPwd: string;
}) => {
  const res = await api({
    method: "post",
    url: memUrl + "certLgnPwd",
    data: parmas,
  });

  return res;
};

/****      * *** */
export const lodGrpListApi = async () => {
  const res = await api({
    method: "get",
    url: "lod/lodGrpList",
  });

  return res;
};

// 매니저 라스트
export const manListApi = async (params: IManList) => {
  const res = await api({
    method: "post",
    url: "manager/getManList",
    data: params,
  });

  return res;
};

// 매니저정보 상세
export const manInfApi = async (manNo: string) => {
  const res = await api({
    method: "get",
    url: `manager/getManDtlInf/${manNo}`,
  });

  return res;
};

// 매니저정보 변경
export const manInfModifyApi = async (params: manModifyProps) => {
  const res = await api({
    method: "post",
    url: "manager/manInfEdit",
    data: params,
  });

  return res;
};

//회원조회
export const userListApi = async (params: Partial<userSearchProps> & page) => {
  const res = await api({
    method: "post",
    url: "member/memList",
    data: params,
  });

  return res;
};

// 회원상세조회
export const userInfApi = async (memNo: string) => {
  const res = await api({
    method: "get",
    // url: `member/memDtlInf/` + `${memNo}`,
    url: `member/memDtlInf/${memNo}`,
  });

  return res;
};
